import { toast } from "react-toastify";
import { requestBackendReportExport } from "./backendReportExport";

export const CAMPAIGN_LIST_V2_REPORT_TYPE = "CAMPAIGNS";

/** Prefer display name key (innerKeys.productName) over id key for export columns. */
export function getCampaignListV2VisibleColumnKeys(columns = []) {
  return columns
    .map((column) => {
      if (typeof column === "string") return column;
      return column?.innerKeys?.productName ?? column?.key;
    })
    .filter(Boolean);
}

export function buildCampaignListV2WrapperExportQueryBody({ query }) {
  return {
    query: { ...query },
  };
}

export async function exportCampaignListV2Report({
  clientId,
  userPlatform = "amazon",
  triggeredBy,
  totalCount,
  queryBody,
  visibleColumnKeys,
  frontendConfig = {},
  setIsExporting = () => {},
  onExportSuccess = () => {},
}) {
  try {
    setIsExporting(true);

    await requestBackendReportExport({
      clientId,
      userPlatform,
      reportType: CAMPAIGN_LIST_V2_REPORT_TYPE,
      totalCount,
      triggeredBy,
      queryBody,
      frontendConfig: {
        columns: visibleColumnKeys,
        ...frontendConfig,
      },
    });

    onExportSuccess();
  } catch (error) {
    console.error(error);
    toast.error(error?.response?.data?.message ?? "Failed to submit export request.");
  } finally {
    setIsExporting(false);
  }
}

